import { SuperAdminService } from "services/superAdminService";

class IntegrationsSAService extends SuperAdminService<any> {
  constructor() {
    super("integrations");
  }
}
export default new IntegrationsSAService();
